import { ReactNode } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { fontSize, getLoginUrl } from "@/components/signup/utils";
import { Link } from "@/libraries/design/components";
import { ExperimentView, experiments } from "@/utils/experiment";
import { useLocation } from "@/utils/location-provider";

import { useAccountCreationContext } from "../../hooks";

export const Login = ({ loginText }: { loginText?: ReactNode }) => {
    return (
        <p css={existingProductCss}>
            <LoginText loginText={loginText} />
        </p>
    );
};

const LoginText = ({ loginText }: { loginText?: ReactNode }) => {
    const intl = useIntl();
    const location = useLocation();
    const { product } = useAccountCreationContext();

    if (loginText !== undefined) {
        return <>{loginText}</>;
    }

    const defaultLoginText = intl.formatMessage(
        {
            id: "BxpUiSignup.SignupForm.existingProduct",
            defaultMessage:
                "Already have {product}? <logInLink>Log in</logInLink>"
        },
        {
            product: product?.description,
            logInLink: (text: ReactNode) => logInLink(text, location)
        }
    );

    if (product?.name !== "service-collection") {
        return <>{defaultLoginText}</>;
    }

    const atlassianAccountLoginText = intl.formatMessage(
        {
            id: "BxpUiSignup.SignupForm.existingAtlassianAccount",
            defaultMessage:
                "Already have an Atlassian account? <logInLink>Log in</logInLink>"
        },
        {
            logInLink: (text: ReactNode) => logInLink(text, location)
        }
    );

    return (
        <ExperimentView
            experiment={experiments.servCoLofiBackground}
            render={(value) => (
                <>{value ? atlassianAccountLoginText : defaultLoginText}</>
            )}
        />
    );
};

const logInLink = (text: ReactNode, location: Location) => (
    <Link
        text={text as unknown as string}
        aria-label={text as unknown as string}
        type="inline"
        href={getLoginUrl(location)}
    />
);

const existingProductCss = css({
    fontSize: fontSize.sm,
    margin: "2rem 0 0 !important",
    textAlign: "center"
});
